/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import MenuIcon from '../icons/MenuIcon';
import BasicButton from './BasicButton';

import styles from '../../styles/buttons/menu-button.module.css';

const propTypes = {
    circleColor: PropTypes.string,
    color: PropTypes.string,
    className: PropTypes.string,
    buttonRef: AppPropTypes.ref,
};

const defaultProps = {
    color: 'currentColor',
    circleColor: null,
    className: null,
    buttonRef: null,
};

function MenuButton({ className, buttonRef, color, circleColor, ...props }) {
    return (
        <BasicButton
            ref={buttonRef}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            {...props}
        >
            <MenuIcon className={styles.icon} color={color} circleColor={circleColor} />
        </BasicButton>
    );
}

MenuButton.propTypes = propTypes;
MenuButton.defaultProps = defaultProps;

// eslint-disable-next-line react/jsx-props-no-spreading
export default React.forwardRef((props, ref) => <MenuButton {...props} buttonRef={ref} />);
